import env from './env.js';

/**
 * @description To encrypt the fingerprint before send it to the API
 * @param {string} str The string to be encrypted
 * @returns {string}
 */
const getStringInRC4 = (str) => {
    const key = env.SUP_SEC_KEY;
    const s = [];
    let j = 0;
    let x;
    let res = '';
    for (let i = 0; i < 256; i++) {
        s[i] = i;
    }
    for (let i = 0; i < 256; i++) {
        j = (j + s[i] + key.charCodeAt(i % key.length)) % 256;
        x = s[i];
        s[i] = s[j];
        s[j] = x;
    }
    let i = 0;
    j = 0;
    for (let y = 0; y < str.length; y++) {
        i = (i + 1) % 256;
        j = (j + s[i]) % 256;
        x = s[i];
        s[i] = s[j];
        s[j] = x;
        res += String.fromCharCode(str.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
    }
    return res;
};
const isServer = typeof process === 'object' && !process.browser;
/**
 * @description To get a specific cookie by name
 * @param {string} cname The cookie name
 * @returns {string}
 */
const getCookie = (cname) => {
    // Checking for browser only
    if (isServer)
        return '';
    const name = cname + '=';
    let decodedCookie = '';
    try {
        decodedCookie = document.cookie;
    }
    catch (e) { }
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        if (!c)
            continue;
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
/**
 * @description To set a named cookie
 * @param {string} name The cookie name
 * @param {string} value The value
 * @param {number} days The validation time
 */
const setCookie = (name, value, days, secure = false) => {
    // Checking for browser only
    if (isServer)
        return;
    let expires = '';
    let securestring = '';
    const domain = '; path=/; domain=.anghami.com;';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    if (secure) {
        securestring = '; secure=true';
    }
    document.cookie = name + '=' + value + expires + securestring + '; path=/; domain=.angha.me;';
    document.cookie = name + '=' + value + expires + securestring + domain;
};
/**
 * @description To remove a named cookie
 * @param {string} name The cookie name
 */
const deleteCookie = (name) => {
    // Checking for browser only
    if (typeof document !== 'object')
        return;
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
const getDeviceName = () => {
    if (typeof window === 'undefined')
        return '';
    const isDesktop = !!window.desktopClient;
    let devicename = '';
    if (isDesktop) {
        devicename = 'Desktop App';
        if (window.desktopClient.platform.computerName) {
            devicename = window.desktopClient.platform.computerName.replace('.local', '');
        }
    }
    else if (typeof getBrowserInfo !== 'undefined') {
        devicename = getBrowserInfo().name + ' ' + getBrowserInfo().version;
    }
    return devicename;
};
const getBrowserInfo = () => {
    if (typeof window === 'undefined')
        return {};
    const ua = window.navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'IE ', version: tem[1] || '' };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);
        if (tem != null) {
            return { name: 'Opera', version: tem[1] };
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    tem = ua.match(/version\/(\d+)/i);
    if (tem != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0],
        version: M[1]
    };
};
/**
 * @description Used to check for restrictions around localStorage usage
 */
const isLocalStorageSupported = () => {
    try {
        const testKey = 'ang_support_test_key_gateway';
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    }
    catch (e) {
        return false;
    }
};
const uuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
// Imported from angularjs to convert object to urlencoded string used on old dashboard endpoints
function jQueryLikeParamSerializer(params) {
    if (!params)
        return '';
    var parts = [];
    serialize(params, '', true);
    return parts.join('&');
    function serialize(toSerialize, prefix, topLevel) {
        if (Array.isArray(toSerialize)) {
            toSerialize.forEach(function (value, index) {
                serialize(value, prefix + '[' + (isNotNullObject(value) ? index : '') + ']', false);
            });
        }
        else if (isNotNullObject(toSerialize) && !isDate(toSerialize)) {
            forEachSorted(toSerialize, function (value, key) {
                serialize(value, prefix + (topLevel ? '' : '[') + key + (topLevel ? '' : ']'), null);
            }, null);
        }
        else {
            parts.push(encodeUriQuery(prefix, null) +
                '=' +
                (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize), null)));
        }
    }
}
/**
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isNotNullObject(value) {
    // http://jsperf.com/isobject4
    return value !== null && typeof value === 'object';
}
function isDate(value) {
    return toString.call(value) === '[object Date]'; // eslint-disable-line no-restricted-syntax
}
function forEachSorted(obj, iterator, context) {
    var keys = Object.keys(obj).sort();
    for (var i = 0; i < keys.length; i++) {
        iterator.call(context, obj[keys[i]], keys[i]);
    }
    return keys;
}
/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
    return encodeURIComponent(val)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/g, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%20/g, pctEncodeSpaces ? '%20' : '+');
}
function serializeValue(v) {
    if (isNotNullObject(v)) {
        return isDate(v) ? v.toISOString() : toJson(v);
    }
    return v;
}
function toJson(obj) {
    if (typeof obj === 'undefined')
        return undefined;
    return JSON.stringify(obj);
}

export { deleteCookie, getCookie, getDeviceName, getStringInRC4, isLocalStorageSupported, isServer, jQueryLikeParamSerializer, setCookie, uuid };
//# sourceMappingURL=utils.js.map
